const type = 'OPEN_CARD_EDIT_PARAM';

const openCardEditParam = (data) => ({
  data,
  type,
});

export { type };
export default openCardEditParam;
